import type { User as IUser } from '@baseball-near-you/prisma';
import { toast } from '@baseball-near-you/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useCreateUserMutation(args?: { showToast?: boolean }) {
  const { showToast = true } = args ?? {};
  const queryClient = useQueryClient();
  const {
    mutateAsync: createUser,
    isLoading: creatingUser,
    error: userError,
  } = useMutation({
    mutationFn: (user: IUser) => {
      return clients.user.createUser({ payload: user });
    },
    onSuccess: async (u) => {
      await queryClient.invalidateQueries([QueryKey.User]);
      if (showToast) {
        toast.success('Profile created!', {
          description: 'Your profile has been created successfully',
        });
      }
    },
    onError: (error: { message?: string }) => {
      toast.error('There was an error creating your profile.', {
        description: error?.message ?? 'Please try again later',
      });
    },
  });
  return {
    createUser,
    creatingUser,
    userError,
  };
}
